module.exports = __webpack_public_path__ + "static/media/fastBox.da7cb47a.jpg";